import React from "react";
import { Link } from "react-router-dom";
import * as PhosphorIcons from "@phosphor-icons/react";
import { ArrowUpRight } from "@phosphor-icons/react";
import { services } from "@/data/services";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#F4F4EB] py-24 md:py-32 border-b border-[#C4C4B5]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-4">
              What We Do
            </div>
            <h2
              data-testid="services-heading"
              className="font-display font-black uppercase tracking-tighter text-[#111110] text-4xl sm:text-5xl md:text-6xl leading-[0.95]"
            >
              Sixteen Services.
              <br />
              One Crew That Shows Up.
            </h2>
          </div>
          <p className="max-w-md text-base md:text-lg text-[#595955] leading-relaxed">
            Whether you&apos;re starting from raw land or finishing the last
            piece of a build, we bring the equipment and the know-how to make it
            happen — start to finish.
          </p>
        </div>

        <div
          data-testid="services-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 border border-[#C4C4B5] bg-[#C4C4B5] gap-px"
        >
          {services.map((s) => {
            const Icon = PhosphorIcons[s.icon] || PhosphorIcons.Wrench;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group bg-[#F4F4EB] hover:bg-[#111110] transition-colors duration-150 p-7 flex flex-col gap-5 min-h-[220px] relative"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 border border-[#111110] flex items-center justify-center bg-[#EAEAE0] group-hover:bg-[#E5231A] group-hover:border-[#E5231A] transition-colors">
                    <Icon
                      size={24}
                      weight="duotone"
                      className="text-[#111110] group-hover:text-[#F4F4EB] transition-colors"
                    />
                  </div>
                  <ArrowUpRight
                    size={20}
                    weight="bold"
                    className="text-[#111110] opacity-0 group-hover:opacity-100 group-hover:text-[#E5231A] transition-opacity"
                  />
                </div>
                <div>
                  <h3 className="font-display font-extrabold uppercase tracking-tight text-lg md:text-xl text-[#111110] group-hover:text-[#F4F4EB] transition-colors">
                    {s.name}
                  </h3>
                  <p className="mt-3 text-sm text-[#595955] group-hover:text-[#F4F4EB]/70 transition-colors leading-relaxed">
                    {s.short}
                  </p>
                </div>
                <span className="mt-auto pt-2 text-[11px] uppercase tracking-[0.25em] font-bold text-[#E5231A] group-hover:text-[#F4F4EB] transition-colors">
                  Learn more →
                </span>
              </Link>
            );
          })}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-5 border border-[#111110] p-6 md:p-8 bg-[#EAEAE0]">
          <div className="flex-1">
            <div className="font-display font-black uppercase text-xl md:text-2xl text-[#111110]">
              Don&apos;t see what you need?
            </div>
            <div className="mt-1 text-[#595955]">
              If it involves dirt, equipment, or building outdoors — just ask.
              Odds are, we do it.
            </div>
          </div>
          <Link
            to="/#contact"
            data-testid="services-cta"
            className="btn-hard inline-flex items-center gap-2 bg-[#E5231A] text-[#F4F4EB] font-bold uppercase text-sm tracking-wider px-6 py-3 border border-[#111110]"
          >
            Ask Michael
            <ArrowUpRight size={16} weight="bold" />
          </Link>
        </div>
      </div>
    </section>
  );
}
